import { render, staticRenderFns } from "./modalDeleteMitra.vue?vue&type=template&id=8f9b0acc"
import script from "./modalDeleteMitra.vue?vue&type=script&lang=js"
export * from "./modalDeleteMitra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports